import React, { useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';

import { AuthService } from '../../services/AuthService';
import useRequest from '../../hooks/useRequest';
import { isMobile } from '../../helpers/Mobile';

import LoginHeader from '../../components/atoms/LoginHeader';
import FooterMobile from '../../components/atoms/FooterMobile';
import GradientButton from '../../components/atoms/GradientButton';

import Icon from '../../components/atoms/Icon';

import './styles.scss';

const ConfirmAccountView = (props) => {
    const history = useHistory();
    const { token } = useParams();

    const {
        submitted, success, message,
        beforeSubmit, afterSubmit, showSuccess, showError,
        dealWithError
    } = useRequest();

    useEffect(() => {
        AuthService.logout();
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        beforeSubmit();
        history.push('/login');
        afterSubmit();
    }

    return (
        <div className="confirm-account-container">
            <LoginHeader></LoginHeader>

            <div className="confirm-account-content">
                <form className="confirm-account-form" onSubmit={handleSubmit}>
                    <h1 className="confirm-account-title">
                        <Icon name="lock" width={26} height={17} fill={isMobile ? '#ffffff' : '#1F3BA3'} /> Cambiar contraseña</h1>
                    <h2 className="confirm-account-subtitle">Tu contraseña fue modificada correctamente</h2>
                    <div className="confirm-account-button">
                        <GradientButton legend={'INGRESAR'} disabled={submitted}
                            handleClick={handleSubmit} type={'submit'} />
                    </div>
                </form>
            </div>
            {isMobile && <FooterMobile></FooterMobile>}
        </div>
    );
}

export default withTranslation()(ConfirmAccountView);